import { Typography } from 'antd';
import styled from 'styled-components';

const Title = styled(Typography.Title)<{ padding?: string }>`
  &&& {
    text-transform: uppercase;
    font-weight: bold;
    line-height: 22px;
    font-size: 18px;
    padding: ${({ padding }) => padding || 'initial'};
  }
`;

export default Title;
